import * as React from "react";
import { size, groupBy, filter } from "lodash";
import { FormError, Form } from "informed";
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { FixedCommentSetFormModel, FixedCommentEntries } from "../types";
import FixedCommentsFormBody from "./FixedCommentSetFormBody";
import { FixedCommentsFormButtons } from "./FixedCommentFormButtons";
import useOrderedComments from "./UserOrderedComments";

interface FixedCommentSetFormProps {
    onSubmit: (values: FixedCommentSetFormModel) => void;
    initalCommentsFormValues: FixedCommentSetFormModel;
    title: string;
    editMode: boolean;
    error: string;
}

export const FixedCommentSetForm = ({ onSubmit, initalCommentsFormValues, title, editMode, error }: FixedCommentSetFormProps): JSX.Element => {
    const formValidator = (values: FixedCommentSetFormModel): FormError => {

        if (!values?.Comments || !size(values?.Comments)) {
            return "There must be at least one fixed comment";
        }

        const duplicateComments = filter(groupBy(values.Comments, c => c.comment), g => g.length > 1);

        if (duplicateComments.length > 0) {
            return "Two comments cannot have the same display text";
        }

        const duplicateDescriptions = filter(groupBy(filter(values.Comments, c => c.description !== "" && c.description !== undefined && c.description !== null), c => c.description), g => g.length > 1);

        if (duplicateDescriptions.length > 0) {
            return "Two comment descriptions cannot have the same text";
        }

        return null;
    }

    const { reset, ...commentProps } = useOrderedComments(initalCommentsFormValues?.Comments);

    const handleImportComments = (entries: FixedCommentEntries) => {
        reset(entries);
    }
    
    return (
        <div className="wrapper wrapper-content">
            <Form id="fixedCommentsForm" initialValues={initalCommentsFormValues} validate={formValidator} onSubmit={onSubmit}>
                {({ formState, formApi }) =>
                (<div className="row">
                    <Alert show={formState.error} category={AlertCategoryEnum.Danger}>
                        {formState.error}
                    </Alert>
                    <Alert show={!!error} category={AlertCategoryEnum.Danger}>
                        {error}
                    </Alert>
                    <div className="col-md-12">
                        <div className="ibox">
                            <div className="ibox-title">
                                <h2 className="text-primary">{title}</h2>
                                <FixedCommentsFormButtons onSubmit={onSubmit} onImportComments={handleImportComments} />
                            </div>
                            <div className="ibox-content">
                                <div id="fixedCommentsList">
                                    <FixedCommentsFormBody {...commentProps} initialState={initalCommentsFormValues} editMode={editMode}  />
                                </div>
                            </div>
                            <div className="ibox-footer">
                                <FixedCommentsFormButtons onSubmit={onSubmit} onImportComments={handleImportComments} />
                            </div>
                        </div>
                    </div>
                </div>)}
            </Form>
        </div>
    );
};
